import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import parse from 'html-react-parser';

const InfoBox = (props) => {
  const { videoLink, content } = props;

  const VideoLinkModal = () => {
    return (
      <a
        className="mt-2"
        href={props.videoLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: 'block', textDecoration: 'underline' }}
      >
        View Video<i className="webconnect webconnect-box-arrow-up-right pt-2"></i>
      </a>
    );
  };
  const DocLinkModal = () => {
    return (
      <a
        className="mt-2"
        href={props.docLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: 'block', textDecoration: 'underline' }}
      >
        View Docs <i className="webconnect webconnect-box-arrow-up-right pt-2"></i>
      </a>
    );
  };
  const showContent = () => {
    if (content) {
      return <DocLinkModal />;
    } else {
      return '';
    }
  };
  const showLink = () => {
    if (videoLink) {
      return <VideoLinkModal />;
    } else {
      return '';
    }
  };

  const popoverRight = (
    <Popover id="popover-trigger-click-root-close">
      <Popover.Title as="h5" className="popover-title">
        <b>{props.popoverTitle}</b>
        <hr />
      </Popover.Title>
      <Popover.Content className="popover-content">
        {/* {props.content} */}
        {/* {isHtml && title ? parse(title) : title} */}
        {props.content ? parse(props.content) : props.content}

        {props.docLink && showContent()}
        {props.videoLink && showLink()}
      </Popover.Content>
    </Popover>
  );

  return (
    <>
      &nbsp;&nbsp;
      {props.popoverTitle && (
        <OverlayTrigger
          trigger={['hover', 'focus']}
          rootClose
          placement="right"
          overlay={popoverRight}
          delay={{ show: 250, hide: 1500 }}
        >
          <FontAwesomeIcon icon={faInfoCircle} style={{ cursor: 'pointer' }} />
        </OverlayTrigger>
      )}
    </>
  );
};

export default InfoBox;
